import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ServicesList from './servicesList';
import ServiceForm from './servicesForm';
import PageError from '../error/pageError';

export default class ServicesOrganization extends React.Component {
    render() {
        const { path } = this.props;

        return (
            <Switch>
                <Route
                    exact
                    path={`${path}/`}
                    render={({ match, history }) => {
                        return <ServicesList organization={this.props.organization} match={match} />;
                    }}
                />

                <Route
                    exact
                    path={`${path}/new`}
                    render={({ match, history }) => {
                        return <ServiceForm organization={this.props.organization} match={match} />;
                    }}
                />

                <Route
                    exact
                    path={`${path}/:serviceId`}
                    render={basenameProps => {
                        const serviceId = basenameProps.match.params.serviceId;
                        return <ServiceForm serviceId={serviceId} organization={this.props.organization} history={basenameProps.history} />;
                    }}
                />
                {/* Error */}
                <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${this.props.organization.id}`} />} />
            </Switch>
        );
    }
}

ServicesOrganization.propTypes = {
    organization: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired
};
